export default{

    projects:[
        {
            title: "Portfolio Project",
            para:"리액트로 만든 포트폴리오 프로젝트 입니다.",
            url:"https://github.com/gandi0330/portfolio-project",
        },
        {
            title: "Bio data analysis Project",
            para:"광주 인공지능 사관학교에서 기업과 연계한 가축 관리 자동화 시스템 프로젝트 입니다.",
            url:"https://github.com/zzinjin98/intflow_project",
        },
        {
            title: "우리 동네 에코 건물은?",
            para:"광주 인공지능 사관학교 시각화 경진대회에서 대상을 받은 시각화 프로젝트 입니다. ",
            url:"https://github.com/gandi0330/Our-Echo-building/tree/master",
        },
        
    ],

    major:[
        {
            para: "Java"
        },
        {
            para: "Spring"
        },
        {
            para: "Mysql"
        },
        
    ],

    knowledges:[
        {
            para: "Java"
        },
        {
            para: "Spring"
        },
        {
            para: "Mysql"
        },
        {
            para: "Python"
        },
        {
            para: "Html"
        },
        {
            para: "Css"
        },
        {
            para: "JavaScript"
        },
        {
            para: "JQuery"
        },
        {
            para: "Git"
        },
        {
            para: "Notion"
        },
        {
            para: "React"
        },
        {
            para: "Github"
        },
        {
            para: "Eclipse"
        },
        {
            para: "VSCode"
        },
        {
            para: "PyCharm"
        },

        
    ]


}